import { render, staticRenderFns } from "./DailyStatementDetail.vue?vue&type=template&id=5801dc5a&"
import script from "./DailyStatementDetail.vue?vue&type=script&lang=js&"
export * from "./DailyStatementDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports